import { createContext } from "react";

export const ModelContext = createContext({});
